var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"UserSettings"},[_vm._v(" "+_vm._s(this.$session.get('IberoJWT'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }